import { render, staticRenderFns } from "./layoutWrongBook.vue?vue&type=template&id=2c66a932&scoped=true&"
import script from "./layoutWrongBook.vue?vue&type=script&lang=js&"
export * from "./layoutWrongBook.vue?vue&type=script&lang=js&"
import style0 from "./layoutWrongBook.vue?vue&type=style&index=0&id=2c66a932&scoped=true&lang=css&"
import style1 from "./layoutWrongBook.vue?vue&type=style&index=1&id=2c66a932&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c66a932",
  null
  
)

export default component.exports